import React from 'react'
import "./banner.css";
import config from "../../config";
import BannerImage from "../../assets/Banner/banner-image.svg"
// import CardOne from "../../assets/Banner/status-up.svg"
const Banner = () => {
    return (
        <section class="banner-section">
            <div class="container">
                <div class="banner-wrapper row">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 banner-text-div">
                        <h1>Agent Scrum: Empowering Agile Teams with Agentic AI</h1>
                        <p>
                            Delivering end-to-end automation of Scrum ceremonies, backlog management, and sprint execution for streamlined performance and agile excellence
                        </p>
                        <div class="banner-button">
                            <a href={config.bookdemo.Link}>
                                <button>
                                    <p>Book Demo</p>
                                </button>
                            </a>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 banner-image">
                        <img src={BannerImage} alt='banner-image' />
                    </div>
                </div>
                <div className='three-card-section row'>
                    <div className='col-12 col-sm-4 col-md-4 col-lg-4'>
                        <div className='card-wrapper'>
                            <img src="https://www.akira.ai/hubfs/smarter-use-of-time-1.svg" alt='card-icon' />
                            <h2> Faster Sprint Execution</h2>
                            <p> Automate Scrum processes to reduce delays and inefficiencies</p>
                        </div>
                    </div>
                    <div className='col-12 col-sm-4 col-md-4 col-lg-4'>
                        <div className='card-wrapper'>
                            <img src="https://www.akira.ai/hubfs/agent-growth-opportunity-icon.svg" alt='card-icon' />
                            <h2>Improved Sprint Planning Accuracy</h2>
                            <p> Enhance backlog prioritization and task estimation with AI intelligence</p>
                        </div>
                    </div>
                    <div className='col-12 col-sm-4 col-md-4 col-lg-4'>
                        <div className='card-wrapper'>
                            <img src="https://www.akira.ai/hubfs/frictionless-production.svg" alt='card-icon' />
                            <h2>  Reduction in Blocker Resolution Time</h2>
                            <p> Identify and resolve impediments faster with proactive AI support</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Banner